<div class="PCILink">
    <div class="instruction">
        Click below to see your Planned Cruise Itinerary.
    </div>
    <div class="pcibutton">
        <button class="btn btn-light nav-item nav-link-edit"><a class="pcilink" href="{{PCIUrl}}{{PCILinkInfo}}">Planned
                Cruise Itinerary</a></button>
    </div>
</div>